import { Skeleton, styled } from '@mui/material';

export const SkeletonPicture = styled(Skeleton)({
  zIndex: 10000,
  position: 'absolute',
  top: 0,
  left: 0,
  background: 'rgba(0,0,0, 0.3)'
});
